import { render, staticRenderFns } from "./add-tema.vue?vue&type=template&id=81a8637a&"
import script from "./add-tema.vue?vue&type=script&lang=js&"
export * from "./add-tema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports